<template>
     <b-card header-tag="header" footer-tag="footer">
        <div>
            <b-carousel id="carousel1" style="text-shadow: 1px 1px 2px #333;" controls indicators background="#ababab" :interval="4000" img-width="640" img-height="300" v-model="slide" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
                <b-carousel-slide v-for="item in billboard" :key="item.id">
                    <template v-slot:img>
                        <img
                        class="d-block class-name banner-image"
                        :src="item.url"
                        alt="image slot">
                    </template>
                </b-carousel-slide>
            </b-carousel>
        </div>
    </b-card>
</template>

<script>
import axios from "axios";

export default {
    name: 'componentBillboard',
    data: function() {
        return {
            slide: 0,
            sliding: null,
            billboard: [{
                    id: 1,
                    url: "img/welcome.webp",
                    caption: "",
                    text: ""
                }
            ],
        }
    },
    methods: {
        variant(value) {
            let $variant
            if (value <= 25) {
                $variant = 'info'
            } else if (value > 25 && value <= 50) {
                $variant = 'success'
            } else if (value > 50 && value <= 75) {
                $variant = 'warning'
            } else if (value > 75 && value <= 100) {
                $variant = 'danger'
            }
            return $variant
        },
        onSlideStart(slide) {
            //console.log('onSlideStart', slide)
            this.sliding = true
        },
        onSlideEnd(slide) {
            //console.log('onSlideEnd', slide)
            this.sliding = false
        },
        openLink() {
            //console.log('Abrindo link..3.');
            //window.open('https://webmail.agulhasnegras.com.br','_blank');
        },
        async refreshData() {
        
            var s = this;
            var currentUserURL = currentUserURL = "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid;
            
            if(currentUserURL.indexOf("undefined") >= 0)
                currentUserURL = ''

            await axios.get(
                this.$store.state.ws_url + "/portal/billboard?companyId=" + this.$store.state.config.companyId + currentUserURL
            ).then(function(resp) {
                s.billboard = resp.data.obj;
            }).catch(function(error) {
                console.log(error)
            })

        }
    },
    mounted: function(){
        this.refreshData();
    }
}
</script>
 
<style scoped>
.banner-image {
    width: 100%
}

</style>